/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import {
  AddCircle,
  AddLinkRounded,
  CreateNewFolder,
  FolderZipRounded,
  SearchRounded,
  UploadFileRounded,
} from '@mui/icons-material';
import {
  Box,
  Menu,
  SwipeableDrawer,
  Table,
  TextField,
  MenuItem,
  CircularProgress,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
} from '@mui/material';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import _ from 'lodash';

import {
  Container,
  Header,
  HeaderPage,
  Page,
  Button,
  BreadCrumbBox,
  BreadCrumbContainer,
  TextCheckBox,
} from './styles';

import { Guest } from '../../../../services/requests/usuarios/types';
import { Folder } from '../../../../services/requests/pastas/types';

import {
  Arquive,
  MultipleUpload,
  createFileRequest,
  createMultipleFilesRequest,
  createZipFileRequest,
  getUsersByCompanyIdRequest,
} from '../../../../services';
import fileApi from '../../../../services/requests/arquivos/fileApi';

import {
  getFoldersByFolderIdRequest,
  postFolderZipRequest,
  removeFolderRequest,
  updateFolderRequest,
} from '../../../../services/requests/pastas/utils';
import { createLogRequest } from '../../../../services/requests/app-logs/utils';

import {
  acceptFileTypes,
  getFileTypeCard,
  maxUploadSize,
} from '../../../../utils/mimeTypes';

import useAuthStore from '../../../../store/auth';
import useCompanyStore from '../../../../store/companies';
import useArquiveStore from '../../../../store/arquives';
import useStatusButtonArchives from '../../../../store/statusButtonArchives';

import DrawerCreateFile from '../CreateFile';
import DrawerAddLink from '../AddLink';
import { FilesList } from '../FilesList';
import { Doc } from '../../../Reuniao/CriarReuniao/Agenda';

import { ConfirmModal } from '../../../../components/ConfirmModal';
import { LoadingBackdrop } from '../../../../components/LoadingBackdrop';
import { ViewerFile } from '../../../../components/ViewerFile';
import { removerDuplicatas } from '../../../../utils/arquivesHelpers';

dayjs().format();

interface GuestToSelect extends Guest {
  selectedFolder: boolean;
}

export const InFolder = () => {
  const navigate = useNavigate();
  const params = useParams();

  const user = useAuthStore(state => state.user);
  const breadcrumbs = useArquiveStore(state => state.breadcrumbs);
  const setBreadcrumbs = useArquiveStore(state => state.setBreadcrumbs);
  const statusButton = useStatusButtonArchives(
    state => state.statusButtonArchives,
  );
  const setStatusButton = useStatusButtonArchives(
    state => state.setStatusButtonArchives,
  );
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const searchForFilesAndFoldersAndLinks = useArquiveStore(
    state => state.searchArchives,
  );
  const setSearchForFilesAndFoldersAndLinks = useArquiveStore(
    state => state.setSearchArchives,
  );

  const [openDrawerCreateFolder, setOpenDrawerCreateFolder] = useState(false);
  const [openDrawerCreateLink, setOpenDrawerCreateLink] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<null | HTMLElement>(null);
  const open = Boolean(openDropdown);
  const [openCreate, setOpenCreate] = useState(false);
  const [openAddArchive, setOpenAddArchive] = useState(false);
  const [openAddLink, setOpenAddLink] = useState(false);
  const [openMoving, setOpenMoving] = useState(false);
  const [openSignatures, setOpenSignatures] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<Doc>({} as Doc);
  const [searchForUsers, setSearchForUsers] = useState('');
  const [openEdit, setOpenEdit] = useState(false);
  const [listagemUsers, setListagemUsers] = useState<GuestToSelect[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [dialogOpenDelete, setDialogOpenDelete] = useState(false);
  const [listaConvidados, setListaConvidados] = useState<Guest[] | undefined>(
    [],
  );
  const [arquivesAndFoldersList, setArquivesAndFoldersList] = useState<any[]>(
    [],
  );
  const [openDocViewer, setOpenDocViewer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [idFolder, setIdFolder] = useState('');
  const [folderSelected, setFolderSelected] = useState<Folder>();
  const [loadingFolder, setLoadingFolder] = useState(false);
  const [year, setYear] = useState('');
  const [statusMeeting, setStatusMeeting] = useState('');
  const [isBoardFolder, setIsBoardFolder] = useState(false);
  const [checked, setChecked] = useState(false);

  const isCreator = folderSelected?.owner_id === user?.id;
  const isOnGuests = folderSelected?.guests?.some(g => g?.id === user?.id);
  const isPrivate = folderSelected?.guests?.some(g => g);
  const isGeneral = statusButton === 'gerais';
  const isMaster = user?.profile === 'UN1';
  const isAdminOnBoard =
    folderSelected?.guests?.find(g => g?.id === user?.id)?.profile ===
    ('BMS1' as any);

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setSearchForFilesAndFoldersAndLinks('');
    setStatusMeeting('');
    setYear('');
  };

  const listFilesAndFoldersAndLinksToFilterToMeetings = arquivesAndFoldersList
    ?.filter(f =>
      (f?.name || f?.original_name)
        ?.toUpperCase()
        ?.includes(searchForFilesAndFoldersAndLinks?.toUpperCase()),
    )
    ?.filter(ff => !ff?.canceled_at)
    ?.filter((fd: any) =>
      fd?.meetings?.length > 0
        ? fd?.meetings[0]?.status?.match(statusMeeting)
        : fd,
    )
    ?.filter((folder: any) =>
      dayjs(
        folder?.meetings?.length > 0 ? folder?.meetings[0]?.start_at : folder,
      )
        ?.get('year')
        ?.toString()
        ?.match(year),
    );

  const showCanceledFolders = arquivesAndFoldersList
    ?.filter(f => f.canceled_at)
    ?.filter(f =>
      (f?.name || f?.original_name)
        ?.toUpperCase()
        ?.includes(searchForFilesAndFoldersAndLinks?.toUpperCase()),
    );

  const listFilesAndFoldersAndLinksToFilter = arquivesAndFoldersList
    .filter(f =>
      (f.name || f.original_name)
        ?.toUpperCase()
        .includes(searchForFilesAndFoldersAndLinks.toUpperCase()),
    )
    ?.filter(ff => !ff?.canceled_at);

  const childernsActives = folderSelected?.childrens?.filter(
    f => !f?.canceled_at,
  );

  const arrTotalYears = childernsActives?.map(f =>
    dayjs(f?.meetings && f?.meetings[0]?.start_at).get('year'),
  );

  const arrTotalYearsWithoutDuplicated = removerDuplicatas(
    arrTotalYears as number[],
  );

  useEffect(() => {
    if (params?.id && isGeneral) {
      if (folderSelected) {
        if (!isCreator && !isOnGuests && isPrivate && !isMaster) {
          return navigate('/home/base-conhecimento');
        }
      }
    }
  }, [params?.id, folderSelected]);

  async function loadFilesByFolderId(baseConhecimentoId: string) {
    setLoading(true);
    try {
      const isInCompany = selectedCompany?.users_ids?.find(
        id => id === user?.doc,
      );

      const response = await getFoldersByFolderIdRequest(
        baseConhecimentoId,
        user?.id as string,
      );

      if (response?.status === 200) {
        const hasMeetings = response?.data?.childrens.some(
          (f: any) => f?.meetings?.length > 0,
        );

        setIsBoardFolder(hasMeetings);

        const foundedFilesInFolder = response?.data;
        setFolderSelected(response?.data);

        const foundedFilesInFolderFormatted =
          foundedFilesInFolder?.childrens?.map((f: any) => ({
            ...f,
            type: getFileTypeCard(f),
          }));

        const listagemPastasFiltradas = foundedFilesInFolderFormatted?.filter(
          (f: any) =>
            f?.guests?.some((u: any) => u.id === user?.id) ||
            f?.owner.name === user?.name,
        );

        const listagemPastasPublicas = foundedFilesInFolderFormatted?.filter(
          (f: any) => f?.guests.length === 0,
        );

        const difference = _.differenceBy(
          listagemPastasFiltradas,
          listagemPastasPublicas,
          'id',
        );

        const concatAll = listagemPastasPublicas?.concat(difference);

        if (isMaster && !isInCompany) {
          setArquivesAndFoldersList(foundedFilesInFolderFormatted);
        } else {
          setArquivesAndFoldersList(concatAll);
        }
      }
    } catch (error) {
      console.log('Error loadFilesByFolderId', error);
    } finally {
      setLoading(false);
    }
  }

  const loadUsers = useCallback(async () => {
    try {
      const response = await getUsersByCompanyIdRequest(
        selectedCompany?.id as string,
        searchForUsers,
        '',
        '100',
        '',
      );
      setListagemUsers(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    if (params && params?.id) {
      loadFilesByFolderId(params?.id);
    }
  }, [params]);

  const handleRemoveFolder = useCallback(async () => {
    const response = await removeFolderRequest(
      idFolder,
      user?.id as string,
      selectedCompany?.id as string,
    );

    // console.log('response remove', response);
    if (response?.status === 200) {
      loadFilesByFolderId(params?.id as string);
      setDialogOpenDelete(false);
    }
  }, [idFolder, user?.id, selectedCompany?.id]);

  const handleOpenDrawerCreateFolder = () => {
    setOpenDrawerCreateFolder(true);
    setOpenDropdown(null);
  };

  const handleOpenDrawerCreateLink = () => {
    setOpenDrawerCreateLink(true);
    setOpenDropdown(null);
  };

  const drawerCreateFolder = () => (
    <DrawerCreateFile
      setOpenDrawerCreateFolder={setOpenDrawerCreateFolder}
      openDrawerCreateFolder={openDrawerCreateFolder}
      listagemPastas={arquivesAndFoldersList}
      setListagemPastas={setArquivesAndFoldersList}
      listagemUsers={listagemUsers}
      folderId={folderSelected?.id as string}
      onLoad={() => loadFilesByFolderId(folderSelected?.id as string)}
      folderName=""
      isNew
      folderSelected={folderSelected}
      setFolderSelected={setFolderSelected}
      loading={loadingUsers}
      searchForUsers={searchForUsers}
      setSearchForUsers={setSearchForUsers}
      setLoadingFolder={setLoadingFolder}
    />
  );

  const drawerCreateLink = () => (
    <DrawerAddLink
      searchForUsers={searchForUsers}
      setSearchForUsers={setSearchForUsers}
      loading={loadingUsers}
      listagemLink={arquivesAndFoldersList}
      setListagemLink={setArquivesAndFoldersList}
      setOpenDrawerCreateLink={setOpenDrawerCreateLink}
      openDrawerCreateLink={openDrawerCreateLink}
      listagemUsers={listagemUsers}
      isNew
      folderSelected={folderSelected}
      setFolderSelected={setFolderSelected}
    />
  );

  const handleUploadFile = useCallback(
    async (files: any) => {
      // console.log({ files });
      try {
        setLoadingUpload(true);
        if (files?.length === 1) {
          const fileData = files[0];

          const data = {
            original_name: fileData.name,
            mimetype: fileData.type,
            size: fileData.size,
            key: fileData.name,
            is_downloaded: true,
            is_main: false,
            is_public: true,
            localFile: fileData,
            owner_id: user?.id,
            folder_id: folderSelected?.id,
          };

          const fileResponse = await createFileRequest(
            data as any,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (fileResponse?.status === 201) {
            const uploadedFile = {
              ...fileResponse?.data,
              files,
              type: 'file',
            };

            const updatedFolder = {
              childrens: [
                ...(folderSelected?.childrens as any),
                { ...uploadedFile },
              ],
              childrens_ids: [
                ...(folderSelected?.childrens_ids as string[]),
                uploadedFile.id,
              ],
            };

            const respFolder = await updateFolderRequest(
              updatedFolder as any,
              folderSelected?.id as string,
              user?.id as string,
              selectedCompany?.id as string,
            );

            if (respFolder?.status === 200) {
              setFolderSelected({ ...respFolder?.data });

              setOpenDropdown(null);

              toast.success('Arquivo salvo com sucesso');

              return setArquivesAndFoldersList([
                ...arquivesAndFoldersList!,
                { ...uploadedFile },
              ]);
            }
          }
        }

        if (files?.length > 1) {
          const folderNameSplited = files[0]?.path?.split('/');

          let folderName = 'null';

          if (folderNameSplited?.length > 1) {
            // eslint-disable-next-line prefer-destructuring
            folderName = folderNameSplited[1];

            // console.log({ folderNameSplited });
          }

          const fileResponse = await createMultipleFilesRequest(
            files,
            user?.id as string,
            folderName,
            params?.id as string,
            selectedCompany?.id as string,
          );

          if (fileResponse?.status === 201) {
            const responseMultipleUpload: MultipleUpload = fileResponse?.data;

            if (responseMultipleUpload.type === 'folder') {
              const uploadedFolder: Partial<Folder | any> = {
                ...responseMultipleUpload?.data,
                type: responseMultipleUpload.type,
                owner: user?.name,
              };

              const updatedFolder = {
                childrens: [
                  ...(folderSelected?.childrens as any),
                  { ...uploadedFolder },
                ],
                childrens_ids: [
                  ...(folderSelected?.childrens_ids as string[]),
                  uploadedFolder?.id as string,
                ],
              };

              const respFolder = await updateFolderRequest(
                updatedFolder as any,
                folderSelected?.id as string,
                user?.id as string,
                selectedCompany?.id as string,
              );

              if (respFolder?.status === 200) {
                setFolderSelected({ ...respFolder?.data });

                setOpenDropdown(null);

                toast.success('Arquivo salvo com sucesso');

                return setArquivesAndFoldersList([
                  ...arquivesAndFoldersList!,
                  { ...uploadedFolder },
                ]);
              }
            }

            const newFiles: any = responseMultipleUpload?.data;

            const uploadedFiles = newFiles?.map((dat: MultipleUpload) => ({
              ...dat,
              type: responseMultipleUpload.type,
              owner: { name: user?.name },
            }));

            const uploadedFilesIds = uploadedFiles.map(
              (uf: Partial<Arquive>) => uf.id,
            );

            const updatedFolder = {
              childrens: [
                ...(folderSelected?.childrens as any),
                ...uploadedFiles,
              ],
              childrens_ids: [
                ...(folderSelected?.childrens_ids as string[]),
                ...uploadedFilesIds,
              ],
            };

            const respFolder = await updateFolderRequest(
              updatedFolder as any,
              folderSelected?.id as string,
              user?.id as string,
              selectedCompany?.id as string,
            );

            if (respFolder?.status === 200) {
              setFolderSelected({ ...respFolder?.data });

              setOpenDropdown(null);

              toast.success('Arquivo salvo com sucesso');

              return setArquivesAndFoldersList([
                ...arquivesAndFoldersList!,
                ...uploadedFiles,
              ]);
            }
          }
          // return console.log('FILES multiplo => ', files);
        }

        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } catch (error) {
        console.error('handleUploadFile Error', error);
        return toast.error(
          'Ocorreu um erro ao fazer o Upload do Arquivo, Tente novamente mais tarde',
        );
      } finally {
        setLoadingUpload(false);
      }
    },
    [selectedCompany?.id, folderSelected, arquivesAndFoldersList, user, params],
  );

  const handleUploadFolderZip = useCallback(
    async (data: any) => {
      try {
        setLoadingUpload(true);

        const selectedFile = data[0];

        const arquiveData = {
          original_name: selectedFile.name,
          mimetype: selectedFile.type,
          size: selectedFile.size,
          key: selectedFile.name,
          is_downloaded: true,
          is_main: false,
          is_public: true,
          localFile: selectedFile,
          folder_id: null,
        };

        const fileResponse = await createZipFileRequest(arquiveData as any);

        const folderZipResponse = await postFolderZipRequest(
          fileResponse as string, // fileKey
          selectedFile.name,
          selectedCompany?.id as string,
          user?.id as string,
          params?.id as string,
        );

        if (folderZipResponse?.status === 201) {
          setOpenDropdown(null);
          toast.success(
            'Arquivo enviado com sucesso, os arquivos estão sendo processados e em breve serão listados',
          );
          loadFilesByFolderId(params?.id as string);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingUpload(false);
      }
    },
    [loadFilesByFolderId, params?.id, selectedCompany?.id, user?.id],
  );

  const handleOpenFileViewer = useCallback(
    async (fileId: any) => {
      try {
        setOpenDocViewer(true);
        setLoadingPreview(true);
        const foundedFile = arquivesAndFoldersList.filter(f => f.id === fileId);

        if (foundedFile.length > 0) {
          let uri = '';
          if (typeof foundedFile[0].id === 'string') {
            uri = await fileApi.getFileUrl(
              foundedFile[0].url,
              user?.id as string,
              selectedCompany?.id as string,
            );
          } else {
            uri = foundedFile[0].url;
          }
          const fileType = foundedFile[0].mimetype;
          const fileName = foundedFile[0].original_name;

          setSelectedDoc({
            uri,
            fileType,
            title: fileName,
            fileId,
          });

          await createLogRequest({
            name: user?.name as string,
            user_id: user?.id as string,
            company_id: selectedCompany?.id as string,
            local: 'Arquivos',
            action: 'Visualizou',
            description: `Visualizou o documento ${fileName} dentro da pasta ${folderSelected?.name}`,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingPreview(false);
      }
    },
    [
      arquivesAndFoldersList,
      folderSelected?.name,
      selectedCompany?.id,
      user?.id,
      user?.name,
    ],
  );

  // const handleGoBack = useCallback(() => {
  //   breadcrumbs.splice(-1);

  //   setBreadcrumbs([...breadcrumbs]);

  //   navigate(-1);
  // }, [breadcrumbs, navigate, setBreadcrumbs]);

  const handleBreadCrumbNavigate = useCallback(
    (bread: any, index: number) => {
      if (bread.id === null) {
        setBreadcrumbs([]);
        statusButton === 'boards'
          ? setStatusButton('boards')
          : setStatusButton('gerais');
        navigate('/home/base-conhecimento');
      } else {
        const initialBreadcrumbs = breadcrumbs.slice(0, index);
        const formatedBreadcrumbs = [...initialBreadcrumbs, { ...bread }];
        navigate(`/home/base-conhecimento/folder/${bread.id}`);
        setBreadcrumbs(formatedBreadcrumbs);
      }
    },
    [breadcrumbs, navigate, setBreadcrumbs, setStatusButton, statusButton],
  );

  return (
    <Container>
      {loadingUpload && (
        <LoadingBackdrop
          text="Carregando arquivos"
          component=""
          loading={loadingUpload}
        />
      )}
      {loadingFolder && (
        <LoadingBackdrop
          text="Carregando pasta"
          component=""
          loading={loadingFolder}
        />
      )}
      <Header>
        <TextField
          placeholder="Pesquisar arquivo ou pasta"
          variant="standard"
          value={searchForFilesAndFoldersAndLinks}
          onChange={ev => setSearchForFilesAndFoldersAndLinks(ev.target.value)}
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '9px 12px',
            width: '100%',
          }}
          InputProps={{
            endAdornment: <SearchRounded />,
            disableUnderline: true, //
          }}
        />
        {statusButton === 'boards' && isBoardFolder && (
          <>
            <FormControl
              sx={{
                width: '30%',
              }}
            >
              <InputLabel id="demo-controlled-open-select-label">
                Status da reunião
              </InputLabel>
              <Select
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                placeholder="Status da reunião"
                disabled={checked}
                label="Status da reunião"
                value={statusMeeting}
                onChange={ev => setStatusMeeting(ev.target.value as string)}
                sx={{
                  background: checked ? 'rgba(0, 0, 0, 0.04)' : '#FFFFFF',
                  borderRadius: '4px',
                  height: '48px',
                }}
              >
                <MenuItem value="">
                  <em>Limpar</em>
                </MenuItem>
                <MenuItem value="MS1">Pautas a definir</MenuItem>
                <MenuItem value="MS2">Pautas definidas</MenuItem>
                <MenuItem value="MS3">Pendente de ata</MenuItem>
                <MenuItem value="MS4">Ata inserida</MenuItem>
                <MenuItem value="MS5">Ata assinada</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ width: '25%' }}>
              <InputLabel id="demo-controlled-open-select-label">
                Ano
              </InputLabel>
              <Select
                value={year}
                disabled={checked}
                onChange={ev => setYear(ev.target.value)}
                labelId="demo-controlled-open-select-label"
                id="demo-controlled-open-select"
                label="Ano"
                sx={{
                  background: checked ? 'rgba(0, 0, 0, 0.04)' : '#FFFFFF',
                  borderRadius: '4px',
                  height: '48px',
                }}
              >
                <MenuItem value="">
                  <em>Limpar</em>
                </MenuItem>
                {arrTotalYearsWithoutDuplicated?.map((y: any) => (
                  <MenuItem key={y?.index} value={y}>
                    {y}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box
              className="checkboxContainer"
              sx={{
                height: '48px',
                alignItems: 'center',
                padding: '10px',
                display: 'flex',
                flexDirection: 'row',
                background: '#ffffff',
                borderRadius: '4px',
              }}
            >
              <Checkbox
                checked={checked}
                onChange={handleChangeCheckbox}
                color="primary"
              />
              <TextCheckBox>Ver canceladas</TextCheckBox>
            </Box>
          </>
        )}
        <React.Fragment key="right">
          {user?.profile === 'UN1' ||
          user?.profile === 'UN2' ||
          isAdminOnBoard ||
          isCreator ? (
            <Button
              variant="contained"
              className="btn-add"
              onClick={event => setOpenDropdown(event.currentTarget)}
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: '10px',
                alignItems: 'center',
                padding: '6px 22px',
                height: '48px',
                minWidth: '142px',
              }}
            >
              <AddCircle />
              Adicionar
            </Button>
          ) : null}
          <Menu
            id="basic-menu"
            anchorEl={openDropdown}
            open={open}
            onClose={() => setOpenDropdown(null)}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
              style: { width: 240 },
            }}
          >
            <MenuItem
              onClick={handleOpenDrawerCreateFolder}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            >
              <CreateNewFolder sx={{ width: '25px', height: '25px' }} />
              <Box
                sx={{ fontSize: '15px', fontWeight: '500', color: '#000000' }}
              >
                Pasta
              </Box>
            </MenuItem>

            <Dropzone
              onDrop={handleUploadFile}
              accept={acceptFileTypes}
              maxSize={maxUploadSize}
              multiple
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Tooltip
                    title="Arquivos validos .pdf, .xlsx, .xls, .ppt, .pptx, .doc, .docx"
                    placement="left"
                  >
                    <MenuItem
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: 'rgba(0, 0, 0, 0.54)',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      <UploadFileRounded
                        sx={{ width: '25px', height: '25px' }}
                      />
                      <input hidden accept="image/*" multiple type="file" />
                      <Box
                        sx={{
                          fontSize: '15px',
                          fontWeight: '500',
                          color: '#000000',
                        }}
                      >
                        Arquivos
                      </Box>
                    </MenuItem>
                  </Tooltip>
                </div>
              )}
            </Dropzone>
            <Dropzone
              onDrop={handleUploadFolderZip}
              accept={{ 'application/zip': ['.zip'] }}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Tooltip
                    title="Certifique-se de que a pasta que está enviando esteja compactada usando o WinRAR para garantir o correto funcionamento no sistema."
                    placement="left"
                    translate="yes"
                    lang="pt"
                  >
                    <MenuItem
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: 'rgba(0, 0, 0, 0.54)',
                        fontSize: '14px',
                        fontWeight: '500',
                      }}
                    >
                      <FolderZipRounded
                        sx={{ width: '24px', height: '24px' }}
                      />

                      <Box
                        sx={{
                          fontSize: '15px',
                          fontWeight: '500',
                          color: '#000000',
                        }}
                      >
                        Pasta zipada
                      </Box>
                    </MenuItem>
                  </Tooltip>
                </div>
              )}
            </Dropzone>
            <MenuItem
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
              onClick={handleOpenDrawerCreateLink}
            >
              <AddLinkRounded sx={{ width: '25px', height: '25px' }} />
              <Box
                sx={{ fontSize: '15px', fontWeight: '500', color: '#000000' }}
              >
                Link Externo
              </Box>
            </MenuItem>
          </Menu>
          <SwipeableDrawer
            onClose={() => setOpenDrawerCreateFolder(false)}
            onOpen={() => setOpenDrawerCreateFolder(true)}
            open={openDrawerCreateFolder}
            anchor="right"
          >
            {drawerCreateFolder()}
          </SwipeableDrawer>
          <SwipeableDrawer
            onClose={() => setOpenDrawerCreateLink(false)}
            onOpen={() => setOpenDrawerCreateLink(true)}
            open={openDrawerCreateLink}
            anchor="right"
          >
            {drawerCreateLink()}
          </SwipeableDrawer>
        </React.Fragment>
      </Header>

      <Page>
        {loading === true ? (
          <Box display="flex" justifyContent="center" width="100%" mt="250px">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <HeaderPage>
              <BreadCrumbContainer>
                {breadcrumbs.map((b: any, i: number) => (
                  <BreadCrumbBox
                    key={b.id}
                    onClick={() => handleBreadCrumbNavigate(b, i)}
                  >
                    <strong>{`${b.name} ${
                      b === breadcrumbs[breadcrumbs.length - 1] ? '' : ' » '
                    } `}</strong>
                  </BreadCrumbBox>
                ))}
              </BreadCrumbContainer>
            </HeaderPage>
            <Table>
              {/* <CardBackSection onClick={handleGoBack}>
                <DriveFolderUploadRounded
                  sx={{
                    color: ' #616161',
                    width: '35px',
                    height: '35px',
                  }}
                />
                <span> Voltar para a pasta anterior</span>
              </CardBackSection> */}
              <FilesList
                files={
                  isBoardFolder
                    ? checked
                      ? showCanceledFolders
                      : isBoardFolder
                      ? listFilesAndFoldersAndLinksToFilterToMeetings
                      : listFilesAndFoldersAndLinksToFilter
                    : listFilesAndFoldersAndLinksToFilter
                }
                setFiles={setArquivesAndFoldersList}
                loading={loading}
                onLoad={() => loadFilesByFolderId(params.id!)}
                handleOpenFileViewer={handleOpenFileViewer}
                isAutomatic={folderSelected?.is_automatic}
                isInFolder
              />
            </Table>
            <ConfirmModal
              open={dialogOpenDelete}
              onClose={() => setDialogOpenDelete(false)}
              title="Tem certeza que deseja descartar este arquivo?"
              subtitle="Isto não pode ser desfeito."
              btnTextCancel="CANCELAR"
              btnTextConfirm="SIM, DESCARTAR"
              type="error"
              onCancel={() => setDialogOpenDelete(false)}
              onConfirm={() => handleRemoveFolder()}
            />
          </>
        )}
      </Page>

      <ViewerFile
        fileUrl={selectedDoc?.uri}
        loading={loadingPreview}
        onClose={() => {
          setOpenDocViewer(false);
          setSelectedDoc({} as Doc);
        }}
        open={openDocViewer}
        title={selectedDoc?.title}
        fileId={selectedDoc?.fileId}
      />
    </Container>
  );
};
